// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/fonts/GilorySemiBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  display: flex;
}

.sidebar {
  width: 250px;
  background-color: #333;
  color: white;
  transition: transform 0.3s ease-in-out;
}

.sidebar.open {
  transform: translateX(0);
}

.sidebar ul {
  list-style: none;
  padding: 0;
}

.sidebar li {
  padding: 10px;
}

.content {
  flex-grow: 1;
  padding: 20px;
}

button {
  margin: 10px;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@font-face {
  font-family: 'Gilory-Semi';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 1200;
  font-style: normal;
}

@font-face {
  font-family: 'Gilory-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 800;
  font-style: normal;
}

span, p, div {
  font-family: 'Gilory-Semi';
}

.openNavIcon {
  font-size: 30px;
  cursor: pointer;
}

.sideNavStyles {
  height: 100%;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: #f8f8fa;
  overflow-x: hidden;
  transition: 0.5s;
}

.navOpenWidth{
  width: 200px;
}

.navCloseWidth{
  width: 0;
} 

.sidenavCloseBtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
  cursor: pointer;
}

.height20 {
  height: 20px;
}

.enableEdit {
  background-color: #ffffff;
}

.disableEdit {
  background-color: #d3d3d3;
}

.profileInputView{
  margin: 0 150px 0 0;
}

.marginLeft110 {
  margin-left: 110px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,0BAA0B;EAC1B,4CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,4CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,UAAU;EACV,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".App {\n  text-align: center;\n  display: flex;\n}\n\n.sidebar {\n  width: 250px;\n  background-color: #333;\n  color: white;\n  transition: transform 0.3s ease-in-out;\n}\n\n.sidebar.open {\n  transform: translateX(0);\n}\n\n.sidebar ul {\n  list-style: none;\n  padding: 0;\n}\n\n.sidebar li {\n  padding: 10px;\n}\n\n.content {\n  flex-grow: 1;\n  padding: 20px;\n}\n\nbutton {\n  margin: 10px;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@font-face {\n  font-family: 'Gilory-Semi';\n  src: url('../src/fonts/GilorySemiBold.ttf');\n  font-weight: 1200;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Gilory-Bold';\n  src: url('../src/fonts/GilorySemiBold.ttf');\n  font-weight: 800;\n  font-style: normal;\n}\n\nspan, p, div {\n  font-family: 'Gilory-Semi';\n}\n\n.openNavIcon {\n  font-size: 30px;\n  cursor: pointer;\n}\n\n.sideNavStyles {\n  height: 100%;\n  position: fixed;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  background-color: #f8f8fa;\n  overflow-x: hidden;\n  transition: 0.5s;\n}\n\n.navOpenWidth{\n  width: 200px;\n}\n\n.navCloseWidth{\n  width: 0;\n} \n\n.sidenavCloseBtn {\n  position: absolute;\n  top: 0;\n  right: 25px;\n  font-size: 36px;\n  margin-left: 50px;\n  cursor: pointer;\n}\n\n.height20 {\n  height: 20px;\n}\n\n.enableEdit {\n  background-color: #ffffff;\n}\n\n.disableEdit {\n  background-color: #d3d3d3;\n}\n\n.profileInputView{\n  margin: 0 150px 0 0;\n}\n\n.marginLeft110 {\n  margin-left: 110px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
